import '../../../../assets/css/screens/customer/dashboard/postajob/PostAJob.css';
import React, { useState, useRef, useContext ,useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import AppNavbar from '../../../../components/customer/dashboard/apphome/appnavbar/AppNavbar';
import {
  ArrowLeft, Tag, FileText, DollarSign,
  MapPin, Calendar, ImagePlus, Send, X, Gavel, Crown
} from 'lucide-react';
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import axios from 'axios';
import AppContext from '../../../../context/AppContext';
import { useLocation } from 'react-router-dom';


const PostAJob = () => {
  const navigate = useNavigate();
  const { baseUrl } = useContext(AppContext);
    const [categories, setCategories] = useState([]);
  const fileRef = useRef(null);
  const [serviceType, setServiceType] = useState('');
  const [jobTitle, setJobTitle] = useState('');
  const [description, setDescription] = useState('');
  const [budget, setBudget] = useState('');
  const [city, setCity] = useState('');
  const [address, setAddress] = useState('');
  const [deadline, setDeadline] = useState('');
  const [bidding, setBidding] = useState('');
  const [media, setMedia] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
const location = useLocation();
useEffect(() => {

  if(location.state?.serviceType){

    setServiceType(location.state.serviceType);

  }

}, [location]);

  // ── Subscription state — replace with your real subscription check ──
  const hasSubscription = false; // TODO: apna actual subscription check yahan lagao



  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const formData = new FormData();
    formData.append('serviceType', serviceType);
    formData.append('jobTitle', jobTitle);
    formData.append('description', description);
    formData.append('budget', budget);
    formData.append('city', city);
    formData.append('address', address);
    formData.append('deadline', deadline);
    formData.append('bidding', bidding === 'yes' ? 1 : 0);
    // formData.append('media', media);

media.forEach(fileObj => {
  formData.append("media[]", fileObj.file);
});

 axios.post(`${baseUrl}/customer/postjob`, formData, {
  headers: {
    'Content-Type': 'multipart/form-data',
    'Authorization': `Bearer ${localStorage.getItem("authToken") || ""}`
  }
}).then((response) => {
  console.log(localStorage.getItem("token"))
      console.log(response.data);
      setLoading(false);

      if (response.data.success) {
        Swal.fire({
          title: 'Job Posted!',
          text: 'Your job has been successfully posted. Providers will contact you soon.',
          icon: 'success',
          confirmButtonText: 'OK',
          showClass: { popup: 'animate__animated animate__fadeInDown' },
          hideClass: { popup: 'animate__animated animate__fadeOutUp' }
        });

        navigate('/my-jobs');

      }
      else {

        alert("Failed to post job");
      }
    })
      .catch((err) => {
        setLoading(false);
        console.log(err);

        alert("Server Error");
      });


  };

  // const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleMedia = (e) => {
    const files = Array.from(e.target.files);

    files.forEach(file => {
      const url = URL.createObjectURL(file);
      setMedia(m => [...m, { file, url, name: file.name, type: file.type }]);
    });
  };

  const removeMedia = (i) => setMedia(m => m.filter((_, idx) => idx !== i));

// category call karna k liya drop down mey 
useEffect(() => {
  axios.get(`${baseUrl}/customer/viewcategories`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("authToken")}`
    }
  })
    .then((response) => {
      console.log(response.data);

      const data = response.data.categories || [];

      const activeCategories = data.filter(
        cat => cat.status == 1
      );

      setCategories(activeCategories);
    })
    .catch((error) => {
      console.log(error);
    });
}, []);


   // Errors
  // const set = (key, val) => {
  //   setForm(p => ({ ...p, [key]: val }));
  //   setErrors(p => ({ ...p, [key]: '' }));
  // };

  // VALIDATION
  // const validate = () => {
  //   const e = {};

  //   const emailErr = RegExpChecker("email", email);
  //   const passwordErr = RegExpChecker("password", password);

  //   if (emailErr.email) e.email = emailErr.email;
  //   if (passwordErr.password) e.password = passwordErr.password;

  //   if (mode === "register") {
  //     const nameErr = RegExpChecker("fullName", fullName);
  //     const phoneErr = RegExpChecker("phone", cnic); // (agar CNIC format same treat karna hai)

  //     if (nameErr.fullName) e.fullName = nameErr.fullName;
  //     if (phoneErr.phone) e.cnic = phoneErr.phone;

  //     if (password !== confirmpassword) {
  //       e.confirmPassword = "Passwords do not match";
  //     }

  //     if (!selectservice) {
  //       e.service = "Service is required";
  //     }
  //   }

  //   return e;
  // };

  return (
    <>
      <AppNavbar />
      <div className="pj-page">
        <div className="pj-container">

          {/* ── Header ── */}
          <div className="pj-header">
            <button className="pj-back" onClick={() => navigate(-1)}>
              <ArrowLeft size={20} />
            </button>
            <h2 className="pj-title">Post a Job</h2>
          </div>

          <p className="pj-subtitle">
            Can't find the right service? Post a custom job and let providers reach out to you.
          </p>

          <form className="pj-form" onSubmit={handleSubmit}>

            {/* Service Type */}
            <div className="pj-custom-select">
              <label className="pj-label">
                <Tag size={15} /> Service Type
              </label>
              <div onClick={() => setOpen(!open)} className="pj-select-box">
                {serviceType || "Select service type"}
              </div>
              {open && (
                <div className="pj-dropdown">
                 {categories.map((cat) => (
  <div
    key={cat.id}
    onClick={() => {
      setServiceType(cat.categoryName || cat.name);
      setOpen(false);
    }}
    className="pj-option"
  >
    {cat.categoryName || cat.name}
  </div>
))}
                </div>
              )}
            </div>

            {/* Job Title */}
            <div className="pj-field">
              <label className="pj-label">
                <FileText size={15} /> Job Title
              </label>
              <input
                type="text"
                className="pj-input"
                placeholder="e.g., Fix kitchen sink leakage"
                value={jobTitle}
                onChange={e => setJobTitle(e.target.value)}
                required
              />
            </div>

            {/* Job Description */}
            <div className="pj-field">
              <label className="pj-label">Job Description</label>
              <textarea
                className="pj-textarea"
                placeholder="Describe the job in detail..."
                value={description}
                onChange={e => setDescription(e.target.value)}
                rows={5}
              />
            </div>

            {/* Budget */}
            {/* <div className="pj-field">
              <label className="pj-label">
                <DollarSign size={15} /> Budget / Tip
              </label>
              <input
                type="number"
                className="pj-input"
                placeholder="Enter your budget or tip ($)"
                value={budget}
                onChange={e => setBudget(e.target.value)}
                min="0"
              />
            </div> */}

            <div className="pj-field">
  <label className="pj-label">
    <DollarSign size={15} /> Budget / Tip
  </label>

  <div className="pj-budget-wrapper">
    
    <span className="pj-currency">$</span>

    <input
      type="number"
      className="pj-input pj-budget-input"
      placeholder="Enter budget"
      value={budget}
      onChange={e => setBudget(e.target.value)}
      min="0"
      required
    />

  </div>
</div>

            {/* City */}
            <div className="pj-field">
              <label className="pj-label">
                <MapPin size={15} /> City
              </label>
              <input
                type="text"
                className="pj-input"
                placeholder="Enter city"
                value={city}
                onChange={e => setCity(e.target.value)}
              />
            </div>

            {/* Complete Address */}
            <div className="pj-field">
              <label className="pj-label">
                <MapPin size={15} /> Complete Address
              </label>
              <input
                type="text"
                className="pj-input"
                placeholder="Enter full address"
                value={address}
                onChange={e => setAddress(e.target.value)}
              />
            </div>

            {/* Deadline */}
            <div className="pj-field">
              <label className="pj-label">
                <Calendar size={15} /> Deadline
              </label>
              <input
                type="date"
                className="pj-input pj-input--date"
                value={deadline}
                onChange={e => setDeadline(e.target.value)}
              />
            </div>

            {/* ── Bidding Field ── */}
            <div className="pj-field">

              {/* Label row: Gavel icon + title + Pro badge right side */}
              <div className="pj-bidding-label-row">
                <label className="pj-label">
                  <Gavel size={15} /> Bidding
                </label>
                <button
                  type="button"
                  className="pj-bidding-pro-badge"
                  // onClick={() => navigate('/customer-subscription')}
                  title="Allow Bidding requires a Pro subscription"
                >
                  <Crown size={11} />
                  <span>Pro Feature</span>
                </button>
              </div>

             <select
  className="pj-input"
  value={bidding}
  onChange={e => {
    const val = e.target.value;

    // Pro subscription check temporarily disabled
    // if (val === 'yes' && !hasSubscription) {
    //   navigate('/customer-subscription');
    //   return;
    // }

    setBidding(val);
  }}
>
                <option value="">Select bidding option</option>
                <option value="yes">🔒 Allow Bidding — Pro</option>
                <option value="no">No Bidding</option>
              </select>

            </div>

            {/* Upload Images / Videos */}
            <div className="pj-field">
              <label className="pj-label">
                <ImagePlus size={15} /> Upload Images / Videos
              </label>
              <p className="pj-upload-hint">Add media to help providers understand the job better.</p>
              <div className="pj-media-row">
                {media.map((m, i) => (
                  <div key={i} className="pj-media-thumb">
                    {m.type.startsWith('video')
                      ? <video src={m.url} className="pj-media-thumb__img" />
                      : <img src={m.url} alt={m.name} className="pj-media-thumb__img" />
                    }
                    <button
                      type="button"
                      className="pj-media-thumb__del"
                      onClick={() => removeMedia(i)}
                    >
                      <X size={12} />
                    </button>
                  </div>
                ))}
                <button
                  type="button"
                  className="pj-upload-btn"
                  onClick={() => fileRef.current.click()}
                >
                  <ImagePlus size={22} />
                  <span>Add</span>
                </button>
                <input
                  ref={fileRef}
                  type="file"
                  accept="image/*,video/*"
                  multiple
                  style={{ display: 'none' }}
                  onChange={handleMedia}
                />
              </div>
            </div>

            {/* Submit */}
            <button
              type="submit"
              className={'pj-submit' + (loading ? ' pj-submit--loading' : '')}
              disabled={loading}
            >
              {loading
                ? <span className="pj-submit__spinner" />
                : <><Send size={16} /> Post Job</>
              }
            </button>

          </form>
        </div>
      </div>
    </>
  );
};

export default PostAJob;